import { render, staticRenderFns } from "./DispatchTableFilter.vue?vue&type=template&id=96dcf6c6&scoped=true"
import script from "./DispatchTableFilter.vue?vue&type=script&lang=js"
export * from "./DispatchTableFilter.vue?vue&type=script&lang=js"
import style0 from "./DispatchTableFilter.vue?vue&type=style&index=0&id=96dcf6c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dcf6c6",
  null
  
)

export default component.exports